import { Link } from "react-router-dom";

const ThankYouPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 text-center">
      <h1 className="text-2xl font-semibold mb-4">Your account was successfully created.</h1>
      <p className="text-gray-600 mb-6">Please check your email to verify your account.</p>
      <Link
        to="/login"
        className="px-5 py-2 bg-green text-white rounded-full text-sm hover:bg-green/90 transition"
      >
        Go to Login
      </Link>
    </div>
  );
};

export default ThankYouPage;
